module.exports = __webpack_public_path__ + "img/orange_051.60075b69.png";